import Moment from 'moment';
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);
import 'moment-timezone';


const symbols = ['second', 'minute', 'hour', 'date', 'month', 'year'];


const intervals = [
  {before: 0.1, chunk: [5, 's'], format: 'H:mm:ss', setStart: 'second'},
  {before: 0.25, chunk: [15, 's'], format: 'H:mm:ss', setStart: 'second'},
  {before: 0.5, chunk: [30, 's'], format: 'H:mm:ss', setStart: 'second'},
  {before: 1.5, chunk: [1, 'm'], format: 'H:mm', setStart: 'second'},
  {before: 2.5, chunk: [2, 'm'], format: 'H:mm', setStart: 'minute'},
  {before: 6.5, chunk: [5, 'm'], format: 'H:mm', setStart: 'minute'},
  {before: 15, chunk: [15, 'm'], format: 'H:mm', setStart: 'minute'},
  {before: 60, chunk: [1, 'h'], format: 'H:mm', setStart: 'minute'},
  {before: 300, chunk: [6, 'h'], format: 'D MMM H:mm', setStart: 'hour'},
  {before: 750, chunk: [12, 'h'], format: 'D MMM H:mm', setStart: 'hour'},
  {before: 1400, chunk: [1, 'd'], format: 'D MMM', setStart: 'hour'},
  {before: 7000, chunk: [5, 'd'], format: 'D MMM', setStart: 'date'},
  {before: 20000, chunk: [15, 'd'], format: 'D MMM', setStart: 'month'},
  {before: 40000, chunk: [1, 'M'], format: 'MMM', setStart: 'month'},
  {before: Infinity, chunk: [1, 'y'], format: 'YYYY', setStart: 'month'}
];


export const colors = {
  chart: 0xffffff,
  background: 0x000000,
  grid: 0xffffff,
  text: 0x929090,
  backgroundTitle: 0xffffff,
  cursorMarks: 0x313131,
  marksTextColor: 0xffffff,
  cursorLines: 0xffffff,
  currentQuoteText: 0x000000,
  winner: 0x009b84,
  loser: 0xff2e2e,
  orderCard: 0x242424,
  orderCardCircle: 0x1B1B1B,
  colorTradeDown: 0xff2e2e,
  colorTradeUp: 0x009b84
};


export const scales = [
  {interval: 1000 * 60 * 250, scale: 1},
  {interval: 1000 * 60 * 1250, scale: 5},
  {interval: 1000 * 60 * 3750, scale: 15},
  {interval: 1000 * 60 * 60 * 125, scale: 30},
  {interval: 1000 * 60 * 60 * 250, scale: 'H'},
  {interval: 1000 * 60 * 60 * 24 * 250, scale: 'D'},
  {interval: 1000 * 60 * 60 * 24 * 7 * 250, scale: 'W'},
  {interval: 1000 * 60 * 60 * 24 * 30 * 250, scale: 'M'}
];


export var EasingFunctions = {
  linear: (t) => t,
  easeInQuad: (t) => t*t,
  easeOutQuad: (t) => t*(2-t),
  easeInOutQuad: (t) => t<.5 ? 2*t*t : -1+(4-2*t)*t,
  easeInCubic: (t) => t*t*t,
  easeOutCubic: (t) => (--t)*t*t+1,
  easeInOutCubic: (t) => t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1,
  easeInQuart: (t) => t*t*t*t,
  easeOutQuart: (t) => 1-(--t)*t*t*t,
  easeInOutQuart: (t) => t<.5 ? 8*t*t*t*t : 1-8*(--t)*t*t*t,
  easeInQuint: (t) => t*t*t*t*t,
  easeOutQuint: (t) => 1+(--t)*t*t*t*t,
  easeInOutQuint: (t) => t<.5 ? 16*t*t*t*t*t : 1+16*(--t)*t*t*t*t
};


export class Point{
  constructor(timestamp, value){
    this.x = 0;
    this.y = 0;
    this.initialTimestamp = timestamp;
    this.initialValue = value;
    this.timestamp = timestamp;
    this.value = value;
  }
}


let getIntervalIndex = (secondsPerPixel) => {
  for (let i = 0; i < intervals.length; i++){
    if (secondsPerPixel < intervals[i].before){
      return i;
    }
  }
};


let setInitialStart = (interval, range) => {
  for (let i = symbols.indexOf(interval.setStart); i >= 0; i--){
    if (i >= 3){
      range.start.set(symbols[i], 1);
    }
    else{
      range.start.set(symbols[i], 0);
    }
  }
};


export var getMoments = (start, end, interval) => {
  let moments = [];
  let rangeBy = moment.range(moment().subtract(...interval.chunk), moment());
  let range = moment.range(start, end);
  setInitialStart(interval, range);
  range.by(rangeBy, (m) => {
    moments.push({moment: m, format: interval.format});
  });
  return moments;
};


export var getStageMoments = (start, end, width) => {
  let intervalIndex = getIntervalIndex((end - start) / 1000 / width);
  let interval = intervals[intervalIndex];
  return getMoments(start, end, interval);
};


export var closest = (num, arr) => {
  let curr = arr[0];
  let diff = Math.abs (num - curr);
  for (let val = 0; val < arr.length; val++) {
    let newDiff = Math.abs (num - arr[val]);
    if (newDiff < diff) {
      diff = newDiff;
      curr = arr[val];
    }
  }
  return curr;
};


export var decimalPlaces = (num) => {
  let strNumber = String(num);
  if (strNumber.indexOf('.') != -1){
    return strNumber.split('.')[1].length;
  }
  return 0;
};


export var getYStep = (distance) => {
  let mantissa = Number(distance.toExponential().split('e')[0]),
      exponent = Number(distance.toExponential().split('e')[1]);
  mantissa *= 10;
  exponent -= 1;
  return Number((closest(mantissa / 12, [1, 2, 5]) * Math.pow(10, exponent)).toFixed(Math.abs(exponent)));
};


export var drawDashedLine = (graphics, x1, y1, x2, y2, width, interval) => {
  let distance = Math.hypot(x2 - x1, y2 - y1);
  let xWidthStep = (width / distance) * (x2 - x1), yWidthStep = (width / distance) * (y2 - y1),
    xIntervalStep = (interval / distance) * (x2 - x1), yIntervalStep = (interval / distance) * (y2 - y1);

  let currentX = x1, currentY = y1;
  while (Math.abs(x2 - currentX) > width || Math.abs(y2 - currentY) > width){
    graphics.moveTo(currentX, currentY);
    currentX += xWidthStep; currentY += yWidthStep;
    graphics.lineTo(currentX, currentY);
    currentX += xIntervalStep; currentY += yIntervalStep;
  }
  if (currentX < x2 || currentY < y2){
    graphics.moveTo(currentX, currentY).lineTo(x2, y2);
  }
};


export var drawFigure = (graphics, points, style = [], clear = false) => {
  if (clear) {
    graphics.clear();
  }
  if (style.length == 2){
    graphics.beginFill(...style);
  }
  if (style.length == 3){
    graphics.lineStyle(...style)
  }

  graphics.moveTo(points[0][0], points[0][1]);
  for (let point of points.slice(1)){
    graphics.lineTo(point[0], point[1]);
  }

  if (style.length == 2){
    graphics.endFill()
  }
};


export var updateLayersOrder = (container) => {
  container.children.sort((a, b) => {
    a.zIndex = a.zIndex || 0;
    b.zIndex = b.zIndex || 0;
    return a.zIndex - b.zIndex;
  });
};


export var getTz = () => {
  if (moment().tz('Europe/Berlin').isDST()){  // we're taking American DST transition dates and applying them to UTC+3/UTC+2 :|
    return {tz: 'Europe/Moscow', offset: 180}; // UTC+3 all-year-round as of 2017
  }
  return {tz: 'Europe/Kaliningrad', offset: 120}; // UTC+2 all-year-round as of 2017
}